<script>
  import { onMount } from "svelte";
  import { Link } from "svelte-routing";
  import emailjs from "@emailjs/browser";
  
  let parallaxImage;
  let containerTop = 0;
  let containerHeight = 0;
  let windowHeight = 0;

  // Contact form state
  let firstName = "";
  let lastName = "";
  let company = "";
  let email = "";
  let phone = "";
  let helpOption = "";
  let message = "";
  let submitting = false;
  let submitStatus = "";

  async function handleSubmit() {
    submitting = true;
    submitStatus = "";

    const payload = {
      title: "Free Consultation Request",
      to_email: "craft2code743@gmail.com",
      name: firstName + " " + lastName,
      from_name: firstName + " " + lastName,
      email: email,
      from_email: email,
      company: company,
      phone: phone,
      help_option: helpOption,
      message: message,
    };

    try {
      const response = await emailjs.send(
        "service_3137pxo",
        "template_kxc76ui",
        payload
      );
      console.log("✅ Email sent successfully!", response.status, response.text);
      submitStatus = "success";
      firstName = ""; lastName = ""; company = ""; email = "";
      phone = ""; helpOption = ""; message = "";
    } catch (err) {
      console.error("❌ EmailJS failed to send email.", err);
      submitStatus = "error";
    }
    submitting = false;
  }

  onMount(() => {
    emailjs.init("fHRZE2qnPN5GaQpnY");
    
    const container = document.querySelector(".parallax-container");
    containerTop = container.offsetTop;
    containerHeight = container.offsetHeight;
    windowHeight = window.innerHeight || document.documentElement.clientHeight;

    window.addEventListener("scroll", handleScrollp);

    return () => {
      window.removeEventListener("scroll", handleScrollp);
    };
  });

  function handleScrollp() {
    const scrollPosition =
      window.pageYOffset || document.documentElement.scrollTop;

    if (
      scrollPosition >= containerTop - windowHeight &&
      scrollPosition <= containerTop + containerHeight
    ) {
      const translation = (scrollPosition - containerTop + windowHeight) * 0.5;
      parallaxImage.style.transform = `translateY(${translation}px)`;
    } else {
      parallaxImage.style.transform = `translateY(0px)`;
    }
  }
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
  />
</svelte:head>

<div class="parallax-container">
  <div class="contentpa">
    <h2>Level Up Your Game Development</h2>
  </div>
</div>

<div class="mob1">
  <div class="mob1-text">
    <h3>Level Up Your Game Development</h3>
    <p>
      Craft2Code brings your gaming ideas to life with end-to-end development
      solutions. From concept and design to launch and post-release support,
      our experienced team ensures every aspect of your game is delivered with
      precision and quality. We provide tailored services to meet your unique
      vision and help you navigate the complexities of modern game development.
    </p>
  </div>
  <div class="mob1-images">
    <img src="/img/28.jpg" alt="Email Marketing Image 1" class="mob1-image" />
    <img src="/img/29.jpg" alt="Email Marketing Image 2" class="mob1-image" />
  </div>
  <div class="mob1-text">
    <h3>Elevating Your Game Development Experience</h3>
    <p>
      At Craft2Code, we specialize in bringing your gaming visions to life.
      From concept design and immersive gameplay mechanics to seamless
      deployment and post-launch support, our team delivers end-to-end game
      development tailored to your project. Every aspect — from storyline and
      user experience to graphics and performance — is crafted with precision
      and creativity to engage players and keep them coming back.
    </p>
  </div>
</div>

<div class="new-section">
  <div class="left-part">
    <i class="fas fa-search fa-2x"></i>
    <div>
      <h3>Research & Analyze</h3>
      <p>
        These cases are perfectly simple and<br />
        easy to distinguish. In a free hour,<br />
        when our power of choice is<br />
        untrammeled.
      </p>
    </div>
  </div>
  <div class="right-part">
    <i class="fas fa-chart-line fa-2x"></i>
    <div>
      <h3>Track & Improve</h3>
      <p>
        These cases are perfectly simple and<br />
        easy to distinguish. In a free hour,<br />
        when our power of choice is<br />
        untrammeled.
      </p>
    </div>
  </div>
</div>

<div class="mob4">
  <div class="left4">
    <h3>Elevating Your Game Development Experience</h3>
    <p>
      At Craft2Code, we specialize in bringing your gaming visions to life.
      From concept design and immersive gameplay mechanics to seamless
      deployment and post-launch support, our team delivers end-to-end game
      development tailored to your project. Every aspect — from storyline and
      user experience to graphics and performance — is crafted with precision
      and creativity to engage players and keep them coming back.
    </p>
    <p><i class="fas fa-check"></i> Global Game Development Expertise — Our developers and designers collaborate worldwide, combining artistic vision with technical mastery to create games that are visually stunning, highly playable, and technically robust.</p>
    <p><i class="fas fa-check"></i> Best Practices in Game Design — We follow proven game development methodologies, including iterative prototyping, performance optimization, and cross-platform integration, ensuring your game is scalable, reliable, and ready for any device or platform.</p>
  </div>
  <div class="right4">
    <img
      src="/img/30.jpg"
      alt="High Quality IT Services"
      class="right4-image"
    />
  </div>
</div>
<div class="card-container1">
  <h2 style="width: 100%; text-align: center; margin-bottom: 20px;">Our Game Development Process</h2>
  <div class="card1">
    <i class="fas fa-gamepad"></i>
    <h2>Game Concept & Design</h2>
    <p>
      We collaborate with you to define your game's vision, storyline,
      mechanics, and visual style, ensuring every element engages your
      target audience.
    </p>
  </div>

  <div class="card1">
    <i class="fas fa-search"></i>
    <h2>Focused Research & Player Insights</h2>
    <p>
      Our team analyzes market trends, player behavior, and competitive
      games to optimize your gameplay, making your game both fun and
      commercially viable.
    </p>
  </div>

  <div class="card1">
    <i class="fas fa-check-circle"></i>
    <h2>Quality Assurance & Testing</h2>
    <p>
      Through rigorous playtesting, bug fixing, and performance optimization,
      we ensure your game runs smoothly across all platforms and devices
      before launch.
    </p>
  </div>
</div>

<div class="cont">
  <div class="leftco">
    <!-- <div class="top-left-text1">Contact Us</div> -->
    <div class="bottom-left-textc">
      Partner with us <br /> for development
    </div>
    <div class="left-text">
      We’re happy to answer any questions you may have and help<br /> you determine
      which of our services best fit your needs.
    </div>
    <div class="left-text">Call us at: 76 361 951</div>
    <div class="left-text">Your benefits:</div>
    <div class="benefits-container">
      <div class="benefits">
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Client-oriented
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Independent
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Competent
        </div>
      </div>
      <div class="benefits">
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Results-driven
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Problem-solving
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Transparent
        </div>
      </div>
    </div>
    <div class="left-text">What happens next?</div>
    <div class="steps">
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We Schedule a call at<br /> your convenience
      </div>
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We do a discovery <br />and consulting meting
      </div>
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We prepare a<br /> proposal
      </div>
    </div>
  </div>
  <div class="rightco">
    <div class="contact-form-container">
      <h2 style="text-align: center;">Schedule a Free Consultation</h2>
      <div class="contact-form">
        <div class="form-group">
          <div class="name-inputs">
            <input
              type="text"
              id="firstName"
              name="firstName"
              placeholder="First Name"
              bind:value={firstName}
              required
            />
            <input
              type="text"
              id="lastName"
              name="lastName"
              placeholder="Last Name"
              bind:value={lastName}
              required
            />
          </div>
        </div>
        <div class="form-group">
          <input
            type="text"
            id="company"
            name="company"
            placeholder="Company/Organization"
            bind:value={company}
          />
        </div>
        <div class="form-group">
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Company Email"
            bind:value={email}
            required
          />
        </div>
        <div class="form-group">
          <input type="text" id="phone" name="phone" placeholder="Phone" bind:value={phone} />
        </div>
        <div class="form-group">
          <select id="helpOption" name="helpOption" bind:value={helpOption}>
            <option value="">How can we help you?</option>
            <option value="Mobile App Development">Mobile App Development</option>
            <option value="Software Development">Software Development</option>
            <option value="Web Development">Web Development</option>
            <option value="Blockchain">Blockchain</option>
            <option value="Game Development">Game Development</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div class="form-group">
          <textarea id="message" name="message" rows="6" placeholder="Message" bind:value={message}
          ></textarea>
        </div>
        {#if submitStatus === "success"}
          <p class="form-success">✅ Message sent successfully! We'll be in touch soon.</p>
        {:else if submitStatus === "error"}
          <p class="form-error">❌ Something went wrong. Please try again or email us at craft2code743@gmail.com</p>
        {/if}
        <button type="button" class="submit-button" disabled={submitting} on:click={handleSubmit}>
          {submitting ? "Sending..." : "Submit"}
        </button>
      </div>
    </div>
  </div>
</div>

<footer class="footer">
  <div class="footer-content">
    <div class="leftfoo">
      <div class="footer-section">
        <div class="links-development">
          <div class="quick-links">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/home" style="color: black;">Home</Link></li>
              <li><Link to="/service" style="color: black;">Services</Link></li>
              <li><Link to="/about" style="color: black;">About Us</Link></li>
              <li>
                <Link to="/contact" style="color: black;">Contact Us</Link>
              </li>
            </ul>
          </div>
          <div class="development">
            <h4>Development</h4>
            <ul>
              <li>
                <Link to="/mobileapp" style="color: black;">Mobile App</Link>
              </li>
              <li>
                <Link to="/software" style="color: black;">Web</Link>
              </li>
              <li><Link to="/game" style="color: black;">Game</Link></li>
              <li><Link to="/web" style="color: black;">Software</Link></li>
              <li>
                <Link to="/blockchain" style="color: black;">Blockchain</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

   
    </div>
    <div class="rightfo">
      <div class="image-containerff">
        <img src="/img/34.png" alt="Footer Image" id="footerImage" />
        <div class="text-overlay12G">
          <h2 style="transform: scale(0.7);"><img src="/img/logo12.png" /></h2>
        </div>
      </div>
    </div>
  </div>
</footer>
<div class="hofo">
  <div class="detail-containerfo">
    <div class="detailfo">
      <p>
        REVIEWED ON
        <span style="color: red;">★</span><span style="color: red;">★</span
        ><span style="color: red;">★</span><span style="color: red;">★</span
        ><span style="color: red;">★</span>
      </p>
      <p>
        <span style="color: black; font-size: 24px;">CLUTCH</span>
        <span style="color: gray;">31 reviews</span>
      </p>
    </div>
    <!-- <div class="vertical-linefo"></div>
    <div class="detailfo blue-textfo">
      <p>God Of Mining</p>
      <p>Lebanon</p>
    </div> -->
    <div class="vertical-linefo"></div>
    <div class="detailfo blue-textfo">
      <p>T: 76 361 951</p>
      <p>E: Info@craft2code.com</p>
    </div>
    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.linkedin.com/company/craft2code" target="_blank">
          <i class="fab fa-linkedin"></i>
        </a>
      </p>
      <p>LinkedIn</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.instagram.com/craft2code/" target="_blank">
          <i class="fab fa-instagram"></i>
        </a>
      </p>
      <p>Instagram</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.facebook.com/craft2code" target="_blank">
          <i class="fab fa-facebook"></i>
        </a>
      </p>
      <p>Facebook</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://maps.app.goo.gl/wCDPsTqkkNU39Fds6" target="_blank">
          <i class="fas fa-map-marker-alt"></i>
        </a>
      </p>
      <p>Location</p>
    </div>
  </div>
  <div class="center-textfooo">
    <p>© 2024Tecnologia Terms & Conditions Privacy Policy</p>
  </div>
</div>

<style>
  /* css for footer */

  .hofo {
    padding: 20px;
  }

  .detail-containerfo {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .detailfo {
    flex: 1;
    text-align: center;
    padding: 10px;
    box-sizing: border-box;
  }

  .vertical-linefo {
    border-left: 1px solid #ccc;
    margin: 0 10px;
  }

  .detailfo p {
    margin: 0;
    font-size: 0.8rem;
  }

  .detailfo .blue-textfo i {
    font-size: 20px;
    margin-bottom: 5px;
  }

  .stars {
    font-size: 24px;
  }

  .blue-textfo p:first-child {
    margin: 0;
    font-size: 0.8rem;
    color: #dc1f26;
  }

  .blue-textfo p:first-child i {
    margin: 0;
    font-size: 1.2rem;
    color: #dc1f26;
  }

  .blue-textfo p:last-child {
    color: black;
  }

  .hofo {
    border-top: 1px solid #ccc;
    padding: 10px 0;
    margin-top: 20px;
  }

  .center-textfooo {
    text-align: center;
    margin-top: 20px;
  }

  .rightfo .image-containerff {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .rightfo img {
    width: 100%;
    height: 100%; /* Make the image take full height */
    object-fit: cover; /* Ensure the image covers the container */
    transition: transform 0.5s; /* Add transition effect for scaling */
  }

  .rightfo img:hover {
    transform: scale(1.1); /* Increase scale on hover */
  }
  .text-overlay12G {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 10;
  }

  .text-overlay12G h2,
  .text-overlay12G button {
    margin-top: 20px; /* Add margin to separate the elements */
  }

  .footer {
    margin-top: 30px;
    display: flex;
    background-color: #ffffff;
    flex-direction: column;
    justify-content: space-between;
    height: auto; /* Set the footer height to full viewport height */
  }
  .footer-content {
    display: flex;
  }

  .leftfoo {
    height: 100%;
    width: 50%;
  }

  .rightfo {
    width: 50%;
    position: relative;
    display: flex;
    justify-content: center; /* Center content vertically */
    align-items: center; /* Center content horizontally */
    text-align: center;
    height: 100%; /* Ensure it takes full height */
  }

  .leftfoo .footer-section {
    margin-bottom: 20px;
  }

  .rightfo button {
    background-color: #39e9e0;
    color: #333333;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .rightfo h2 {
    color: #333333;
    font-family: BreeSerif;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .leftfoo .footer-section h4 {
    color: #333333;
    font-size: 1.8rem;
    font-family: SourceSans;
    font-weight: bold;
    margin-top: 65px;
  }

  .leftfoo .footer-section ul {
    list-style: none;
    padding-top: 0px;
    margin-top: 0;
  }

  .leftfoo .footer-section ul li {
    padding-top: 10px;
    margin-bottom: 10px;
  }

  .leftfoo .footer-section ul li a {
    color: #333333;
    font-family: SourceSans;
    text-decoration: none;
  }

  .leftfoo .footer-section ul li a:hover {
    color: #dc1f26;
  }

  .leftfoo .footer-section input[type="email"] {
    margin-top: 50px;
    padding: 15px;
    border: none;
    border-radius: 5px;
    margin-bottom: 10px;
    margin-left: 20px;
    background-color: #333333;
    color: white;
    border: 2px solid white; /* Set transparent border by default */
    width: calc(100% - 200px); /* Adjusted width to account for margin */
  }

  .leftfoo .footer-section input[type="checkbox"] {
    margin-top: 15px;
    margin-left: 30px;
    margin-right: 10px;
    transform: scale(1);
  }

  .leftfoo .footer-section .checkbox-wrapper {
    display: inline-flex;
    align-items: center;
    margin-top: 15px;
  }
  .leftfoo .footer-section label {
    padding-right: 200px;
    font-size: 0.8rem; /* Increase font size of the checkbox label */
  }
  .leftfoo .footer-section button {
    background-color: #333333;
    margin-left: 30px;
    margin-top: 40px;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 30px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .leftfoo .footer-section button:hover {
    background-color: #dc1f26;
  }
  .rightfo h2 {
    z-index: 10;
  }

  .rightfo button {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .rightfo button::before,
  .rightfo button::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .rightfo button::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .rightfo button::after {
    right: 50%;
    transform: translateX(50%);
  }

  .rightfo button:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .rightfo button:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .rightfo button:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }

  .links-development {
    display: flex;
  }

  .quick-links,
  .development {
    margin-left: 30px;
    padding-top: 5px;
    flex: 1;
  }

  .quick-links ul,
  .development ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .quick-links h4,
  .development h4 {
    font-size: 1.9rem;
  }

  /* css for contact */
  .cont {
    padding-top: 70px;
    display: flex;
    /* background: linear-gradient(
      to bottom,
      white 0%,
      white 19%,
      #dc1f26 20%,
      red 70%,
      white 71%
    ); */
    /* background: linear-gradient(45deg, #ffffff, #dc1f26, #ffffff); */
    width: 100%;
  }

  .leftco {
    flex: 70%; /* Set the left div to take up 70% of the available space */
    color: #333333;
    padding-left: 120px;
  }

  .left-text {
    padding-top: 50px;
    font-size: 1.3em;
    font-family: BreeSerif;
  }

  .benefits-container {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
  }

  .benefits {
    flex: 1;
    font-family: BreeSerif;
  }

  .benefit {
    padding: 5px 0;
    font-family: SourceSans;
  }

  .benefit i {
    margin-right: 10px;
  }

  .steps {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    font-family: BreeSerif;
  }

  .step {
    padding-bottom: 20px;
    flex: 1;
    font-family: SourceSans;
  }

  .top-left-text1 {
    /* top: 20px; */
    padding-top: 0px;
    margin-top: 0px;
    font-family: SourceSans;

    font-size: 18px;
  }
  .name-inputs {
    display: flex;
  }

  .name-inputs input {
    flex: 1; /* Take up equal space */
    margin-right: 10px; /* Add space between inputs */
  }

  .name-inputs input:last-child {
    margin-right: 0; /* Remove margin from last input */
  }
  .rightco {
    background-color: white;
    /* margin-top: 10px; */
    margin-right: 200px;
    margin-bottom: 30px;
    flex: 50%; /* Set the right div to take up 30% of the available space */
  }

  .contact-form-container {
    display: flex;
    flex-direction: column; /* Align items vertically */
    align-items: center; /* Center items horizontally */
    padding-right: 20px;
  }

  .contact-form-container h2 {
    color: #333333;
    font-family: BreeSerif;
    margin-bottom: 20px;
  }

  .form-group {
    margin-bottom: 20px;
    text-align: left;
    padding-left: 10px;
  }

  .form-group input,
  .form-group select,
  .form-group textarea {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .form-group select {
    appearance: none;
    -webkit-appearance: none;
  }

  .form-group textarea {
    resize: vertical;
  }

  .submit-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .form-success {
    color: #1a7a3a;
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
    border-radius: 5px;
    padding: 10px 15px;
    margin-bottom: 12px;
    font-size: 0.95rem;
  }

  .form-error {
    color: #842029;
    background-color: #f8d7da;
    border: 1px solid #f5c2c7;
    border-radius: 5px;
    padding: 10px 15px;
    margin-bottom: 12px;
    font-size: 0.95rem;
  }

  .submit-button {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .submit-button::before,
  .submit-button::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .submit-button::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .submit-button::after {
    right: 50%;
    transform: translateX(50%);
  }

  .submit-button:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .submit-button:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .submit-button:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }

  .bottom-left-textc {
    font-size: 60px;
    margin-top: 0px;
    font-weight: bold;
    font-family: SourceSans;
  }
  .testimonials-section {
    position: relative;
    text-align: center;

    width: 60%;
    margin-left: auto; /* Auto margin from left */
    margin-right: auto; /* Auto margin from right */
  }

  .testimonial {
    padding: 30px 0; /* Increase padding */
  }

  .quote {
    font-style: italic;
    font-size: 1.7rem; /* Increase font size */
    margin-bottom: 20px;
    width: 100%;
    text-align: left;
    font-weight: bold;
    font-family: BreeSerif;
  }
  .clients-text {
    color: #333333;
    font-family: BreeSerif;
    font-size: 60px; /* Adjust font size */
    margin-bottom: 20px;
  }

  .author {
    font-size: 1.2rem; /* Increase font size */
    font-family: SourceSans;
    color: #333333;
    margin-bottom: 20px;
    margin-top: 30px;
    text-align: left;
  }

  .arrow-buttons-container {
    margin-left: 20px; /* Add margin between buttons and text */
  }

  .additional-info1 {
    display: flex;
    justify-content: space-between; /* Align items to the edges */
    align-items: center; /* Center vertically */
    margin-top: 1px; /* Adjust as needed */
  }

  .detail1 {
    font-size: 1.2rem;
    text-align: right; /* Align text to the right */
  }
  .arrow-button {
    background: none;
    border: none;
    cursor: pointer;
    color: #054f76;
    font-size: 24px;
    margin: 0 10px; /* Add some space between buttons */
  }

  .arrow-button.left11 {
    margin-right: 20px;
  }

  .arrow-button.right11 {
    margin-left: 20px;
  }

  .additional-info2 {
    display: flex;
    align-items: center;
  }
  /* ---------------------------------------------------------------- */
  .mob1 {
    display: flex;
    flex-direction: column;
  }

  .mob1-text {
    padding: 20px;
    text-align: center;
  }
  .mob1-text h3 {
    font-size: 50px;
    font-family: BreeSerif;
  }
  .mob1-images {
    display: flex;
    justify-content: space-around;
  }

  .mob1-image {
    width: 45%;
    height: auto;
  }

  .card-container1 {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    margin-top: 40px;
    padding-bottom: 80px;
  }

  .card1 {
    /* Removed transition property for demonstration */
    width: 20%; /* Adjusted width */
    min-height: 300px;
    height: auto;
    background-color: #ffffff;
    padding: 20px;
    border-radius: 10px;

    display: flex;
    flex-direction: column;
    justify-content: space-between; /* Adjusted alignment */

    position: relative;
  }

  .card1 i {
    font-size: 80px;
    color: black;
    text-align: center;
  }
  .card1 i:hover {
    color: #dc1f26;
  }
  .card1 h2 {
    text-align: center;
    color: #333333;
    font-family: BreeSerif;
    font-size: 1.7rem;
    margin-bottom: 0px; /* Add margin bottom */
  }

  .card1 p {
    text-align: center;
    font-family: SourceSans;
    color: #333333;
    font-size: 1.3rem;
    margin-bottom: 10px; /* Add margin bottom */
  }

  .parallax-container {
    position: relative;
    width: 100%;
    height: 100vh; /* Adjust height as needed */
    margin-bottom: 30px;
    margin-top: 20px;
    background-image: url("/img/27.jpg"); /* Image path */
    background-attachment: fixed; /* Parallax effect */
    background-size: cover; /* Ensure the image covers the container */
    background-position: center; /* Center the image */
    background-repeat: no-repeat; /* Prevent image repetition */
  }

  .contentpa {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    text-align: center;
    font-size: 50px;
    font-family: BreeSerif;
    color: white;
  }

  .buttonpa {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .buttonpa::before,
  .buttonpa::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .buttonpa::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .buttonpa::after {
    right: 50%;
    transform: translateX(50%);
  }

  .buttonpa:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .buttonpa:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .buttonpa:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }

  .new-section {
    width: 60%;
    display: flex;
    justify-content: space-around;
    margin-left: auto;
    margin-right: auto;
  }

  .left-part,
  .right-part {
    display: flex;
    align-items: center;
    width: 45%;
  }

  .left-part i,
  .right-part i {
    margin-right: 10px;
    color: #333;
  }

  .left-part h3,
  .right-part h3 {
    margin-bottom: 10px;
  }

  .left-part p,
  .right-part p {
    line-height: 1.6;
  }

  .mob4 {
    width: 100%;
    display: flex;
  }

  .left4,
  .right4 {
    width: 50%;
    padding: 20px;
  }

  .left4 {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .left4 h3 {
    margin-bottom: 20px;
    font-size: 46px;
    font-family: BreeSerif;
  }

  .left4 p {
    margin-bottom: 10px;
    line-height: 1.6;
  }

  .left4 i {
    color: green;
    margin-right: 10px;
  }

  .right4-image {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
  @media (min-width: 1024px) and (max-width: 1324px) {
    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 50px;
      padding-right: 50px;
    }

    .rightco {
      margin-right: 50px;
      margin-left: 50px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
    }

    .bottom-left-textc {
      font-size: 3rem;
      text-align: center;
    }

    .left-text {
      font-size: 1.1rem;
      text-align: center;
    }
    .mob4 {
      flex-direction: row; /* Place image beside the left section */
    }
    .left4,
    .right4 {
      width: 50%; /* Equal width for both sections */
      padding: 20px; /* Adjust padding */
    }
    .left4 h3 {
      font-size: 36px; /* Adjust font size */
    }
    .left4 p {
      font-size: 16px; /* Adjust paragraph font size */
    }
    .right4-image {
      height: 100%; /* Ensure image height matches the text section */
      object-fit: cover; /* Cover the available space */
    }
    .rightfo button {
      padding: 10px 16px; /* Adjust button padding */
      font-size: 16px; /* Adjust button font size */
    }
  }
  @media (min-width: 769px) and (max-width: 1025px) {
    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 50px;
      padding-right: 50px;
    }

    .rightco {
      margin-right: 50px;
      margin-left: 50px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      padding-left: 30%;
    }

    .bottom-left-textc {
      font-size: 3rem;
      text-align: center;
    }

    .left-text {
      font-size: 1.1rem;
      text-align: center;
    }
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }

    .leftfoo .footer-section h4 {
      font-size: 1.3rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.75rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 0;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 15px; /* Adjust font size */
    }
    .hofo {
      padding: 10px; /* Adjust padding */
      flex-direction: row;
    }

    .detail-containerfo {
      display: flex;
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%; /* Two items per row */
      box-sizing: border-box;
    }

    .vertical-linefo {
      display: none; /* Hide vertical lines */
    }

    .detailfo:nth-child(1),
    .detailfo:nth-child(2),
    .detailfo:nth-child(3) {
      width: 100%; /* Make the first three items take the full width */
    }

    .center-textfooo {
      font-size: 0.9rem; /* Adjust font size */
    }
    .left4 h3 {
      font-size: 36px; /* Adjust font size for medium screens */
    }
    .left4 p {
      font-size: 16px; /* Adjust paragraph font size */
    }
    .rightfo button {
      padding: 10px 14px; /* Adjust button padding */
      font-size: 15px; /* Adjust button font size */
    }
    .mob4 {
      flex-direction: column; /* Stack left and right sections */
    }
    .left4,
    .right4 {
      width: 100%; /* Full width for both sections */
      padding: 0; /* Reduce padding */
    }
    .right4 {
      order: 2; /* Place image below left section */
    }
    .left4 {
      order: 1; /* Ensure text is above the image */
    }
    .new-section {
      width: 100%;
    }
  }
  @media (min-width: 481px) and (max-width: 768px) {
    .mob1 {
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }
    .contentpa {
      font-size: 40px;
    }

    .new-section {
      width: 90%;
      flex-direction: row;
    }

    .left-part,
    .right-part {
      width: 100%;
      margin-bottom: 20px;
    }

    .card1 {
      width: 40%;
    }

    .card-container1 {
      flex-direction: column;
      align-items: center;
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }

    .card1 {
      width: 80%;
      margin-bottom: 20px;
    }
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }
        .text-overlay h2 {
      margin-top: 0; /* Adjust margin to remove distance */
        }
    .leftfoo .footer-section h4 {
      font-size: 1.2rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.7rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 0;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 14px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
      flex-direction: row;
    }

    .detail-containerfo {
      display: flex;
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%; /* Two items per row */
      box-sizing: border-box;
    }

    .vertical-linefo {
      display: none; /* Hide vertical lines */
    }

    .detailfo:nth-child(1),
    .detailfo:nth-child(2),
    .detailfo:nth-child(3) {
      width: 100%; /* Make the first three items take the full width */
    }

    .center-textfooo {
      font-size: 0.8rem; /* Adjust font size */
    }
    .rightfo button {
      padding: 8px 8px; /* Adjust padding for smaller screens */
      font-size: 14px; /* Reduce font size for smaller screens */
    }
    .rightfo h2 img {
      transform: scale(1); /* Adjust the scale of the image */
    }

    .text-overlay h2 {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
      padding-bottom: 0px;
    }

    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 20px;
      padding-right: 20px;
    }

    .rightco {
      margin-right: 20px;
      margin-left: 20px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      padding-left: 30%;
    }

    .bottom-left-textc {
      font-size: 2rem;
      text-align: center;
    }

    .left-text {
      font-size: 1rem;
      text-align: center;
    }

    .vertical-linefo {
      display: none; /* Hide vertical line */
    }

    .center-textfooo {
      font-size: 0.9rem; /* Adjust font size */
    }
    .parallax-container {
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
      display: none;
    }
    .left4 h3 {
      font-size: 32px; /* Adjust font size for small screens */
    }
    .left4 p {
      font-size: 14px; /* Adjust paragraph font size */
    }
    .rightfo button {
      padding: 8px 12px; /* Adjust button padding */
      font-size: 14px; /* Adjust button font size */
    }
    .mob4 {
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
      flex-direction: column; /* Stack left and right sections */
    }
    .left4,
    .right4 {
      width: 100%; /* Full width for both sections */
      padding: 0px; /* Reduce padding */
    }
    .right4 {
      order: 2; /* Place image below left section */
    }
    .left4 {
      order: 1; /* Ensure text is above the image */
    }
  }
  @media (max-width: 480px) {
    .parallax-container {
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      display: none;
    }
    .contentpa {
      font-size: 30px;
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
    }

    .new-section {
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      width: 90%;
      flex-direction: column;
    }

    .left-part,
    .right-part {
      width: 100%;
      margin-bottom: 20px;
    }
    .left4,
    .right4 {
      width: 100%; /* Full width for both sections */
      padding: 10px; /* Reduce padding */
    }
    .mob4 {
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      width: 100%;
      flex-direction: column; /* Stack left and right sections */
    }
    .right4 {
      order: 2; /* Place image below left section */
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
    }
    .left4 {
      order: 1; /* Ensure text is above the image */
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
    }
    .left4 h3 {
      font-size: 28px; /* Adjust font size for extra small screens */
      margin-bottom: 15px; /* Adjust margin */
    }
    .left4 p {
      font-size: 12px; /* Adjust paragraph font size */
      margin-bottom: 8px; /* Adjust margin */
      line-height: 1.4; /* Adjust line height */
    }
    .card1 {
      width: 50%;
    }

    .card-container1 {
      flex-direction: column;
      align-items: center;
    }

    .card1 {
      width: 90%;
      margin-bottom: 20px;
    }
    .mob1 {
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      width: 100%;
    }
    .mob1-text h3 {
      font-size: 36px;
    }

    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }
        .text-overlay h2 {
      margin-top: 0; /* Adjust margin to remove distance */
        }
    .leftfoo .footer-section h4 {
      font-size: 1.2rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.7rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 30px;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 14px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
    }

    .detail-containerfo {
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%;
      box-sizing: border-box;
    }

    .detailfo:nth-child(3) {
      width: 100%; /* Full width for the address section */
      padding: 10px 0; /* Add some padding for the address section */
    }

    .vertical-linefo {
      display: none;
    }
    .center-textfooo {
      font-size: 0.8rem; /* Adjust font size */
    }
    .rightfo button {
      padding: 8px 8px; /* Adjust padding for smaller screens */
      font-size: 14px; /* Reduce font size for smaller screens */
    }
    .rightfo h2 img {
      transform: scale(1); /* Adjust the scale of the image */
    }

    .text-overlay h2 {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
      padding-bottom: 0px;
    }

    .cont {
      flex-direction: column;
      padding-top: 0px;
      margin-top: 0px;
    }

    .leftco {
      padding-left: 20px;
      margin-top: 0px;
      padding-top: 0px;
      padding-right: 20px;
    }

    .rightco {
      margin-right: 20px;
      margin-left: 20px;
      flex: 100%;
    }
    .benefits-container,
    .steps {
      flex-direction: column;
      width: 50%;
      margin-left: auto;
      margin-right: auto;
    }

    .bottom-left-textc {
      font-size: 2rem;
      text-align: center;
      padding-top: 0px;
      margin-top: 0px;
    }

    .left-text {
      font-size: 1rem;
      text-align: center;
    }
  }
</style>
